import React from "react";
import {
  Dialog,
  DialogContent,
  Typography,
  Button,
  Box,
} from "@mui/material";

const GoogleSuccessModal = ({ open, onClose, number }) => {

const handleReload = () => {
  localStorage.removeItem("google_jwt")
  setTimeout(() => {
    window.location.reload();
  }, 200);
  // Reloads the current page
};

  return (
    <Dialog
      open={true}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: 3,
          textAlign: "center",
          width: "90%",
          maxWidth: 380,
          overflow: "hidden",
          p: 2,
          pb: 0,
        },
      }}
    >
      <DialogContent>
        {/* SVG Circle Check */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            position: "relative",
            top: "-40px",
            mt: 5,
          }}
        >
          <svg
            style={{ width: "87px" }}
            xmlns="http://www.w3.org/2000/svg"
            width="96"
            height="96"
            viewBox="0 0 96 96"
            fill="none"
          >
            <path
              d="M95 48C95 51.94 88.56 54.98 87.58 58.6C86.58 62.36 90.62 68.2 88.7 71.5C86.76 74.84 79.66 74.26 76.96 76.96C74.26 79.66 74.84 86.78 71.5 88.7C68.2 90.6 62.36 86.56 58.6 87.58C54.96 88.56 51.94 95 48 95C44.06 95 41.02 88.56 37.4 87.58C33.64 86.58 27.8 90.62 24.5 88.7C21.16 86.76 21.74 79.66 19.04 76.96C16.34 74.26 9.22 74.84 7.3 71.5C5.4 68.2 9.44 62.36 8.42 58.6C7.44 54.98 1 51.94 1 48C1 44.06 7.44 41.02 8.42 37.4C9.42 33.64 5.38 27.8 7.3 24.5C9.24 21.16 16.34 21.74 19.04 19.04C21.74 16.34 21.16 9.22 24.5 7.3C27.8 5.4 33.64 9.44 37.4 8.42C41.02 7.44 44.06 1 48 1C51.94 1 54.98 7.44 58.6 8.42C62.36 9.42 68.2 5.38 71.5 7.3C74.84 9.24 74.26 16.34 76.96 19.04C79.66 21.74 86.78 21.16 88.7 24.5C90.6 27.8 86.56 33.64 87.58 37.4C88.56 41.02 95 44.06 95 48Z"
              fill="#049E79"
            />
            <path
              d="M48.0001 78.9201C65.0767 78.9201 78.9201 65.0767 78.9201 48.0001C78.9201 30.9234 65.0767 17.0801 48.0001 17.0801C30.9234 17.0801 17.0801 30.9234 17.0801 48.0001C17.0801 65.0767 30.9234 78.9201 48.0001 78.9201Z"
              fill="#068463"
            />
            <path
              d="M65.6602 36.46C64.1002 34.9 61.5602 34.9 60.0002 36.46L43.2402 53.22L35.3202 45.3C33.7602 43.74 31.2202 43.74 29.6602 45.3C28.1002 46.86 28.1002 49.4 29.6602 50.96L40.4202 61.72C41.1802 62.48 42.2002 62.9 43.2602 62.9C44.3202 62.9 45.3402 62.48 46.1002 61.72L65.6802 42.12C67.2202 40.56 67.2202 38.02 65.6602 36.46Z"
              fill="white"
            />
          </svg>
        </Box>

        {/* Text Content */}
        <Box sx={{ position: "relative", top: "-40px", px: 2 }}>
          <Typography variant="h6" fontWeight={700}>
            Successful
          </Typography>

          <Typography
            variant="body2"
            fontWeight={400}
            sx={{ mt: 2, color: "#334155" }}
          >
            Your mobile is linked. Proceed to payment and enjoy your order.
            {number && <strong> {number}</strong>}
          </Typography>

          {/* Done Button */}
          <Button
            variant="contained"
            onClick={handleReload}
            fullWidth
            sx={{
              mt: 4,
              py: 1.2,
              borderRadius: "10px",
              backgroundColor: "rgba(0,177,119,1)",
              fontWeight: 700,
              fontSize: "15px",
              textTransform: "none",
              "&:hover": { backgroundColor: "rgba(0,150,100,1)" },
            }}
          >
            Done
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default GoogleSuccessModal;
